import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LangPage } from './lang';

@NgModule({
  declarations: [
    LangPage,
  ],
  imports: [
    IonicPageModule.forChild(LangPage),
  ],
  entryComponents: [
    LangPage,
  ]
})
export class LangPageModule {}



// WEBPACK FOOTER //
// ./src/pages/lang/lang.module.ts